import gql from 'graphql-tag'

export const STAFF_GET_DOCTOR_CAR_COMMUTING_APPLICATION = gql`
  query DoctorCarCommutingApplication(
    $orderBy: MyCarCommutingApplicationOrderByInput
    $where: MyCarCommutingApplicationWhereInput
  ) {
    myCarCommutingApplications(orderBy: $orderBy, where: $where) {
      id
      approvalStatus
      frontSideLicenseKey
      backSideLicenseKey
      expirationDate
      carCommuteStartDate
      vehicleInspectionCertificateKey
      liabilityInsuranceCertificateKey
      voluntaryInsuranceCertificateKey
      vehicleInspectionExpirationDate
      vehicleType
      licensePlateNumberPart1
      licensePlateNumberPart2
      licensePlateNumberPart3
      licensePlateNumberPart4
      lastAppliedDate
      voluntaryInsuranceCertificateExpirationDate
      liabilityInsuranceCertificateExpirationDate
      doctor {
        firstname
        lastname
      }
    }
  }
`

export const STAFF_MUTATION_APPROVE_DOCTOR_CAR_COMMUTING_APPLICATION = gql`
  mutation staffUpdateDoctorCarCommutingApplication(
  $id: String!, $doctorId: ID!, 
  $status: String!, $msg: String,
  $vehicleType: String, $backSideLicenseKey: String,
  $frontSideLicenseKey: String, $licensePlateNumberPart1: String,
  $licensePlateNumberPart2: String, $licensePlateNumberPart3: String, $licensePlateNumberPart4: String,
  $expirationDate: DateTime, $vehicleInspectionExpirationDate: DateTime, $voluntaryInsuranceCertificateKey: String,
  $carCommuteStartDate: DateTime,$vehicleInspectionCertificateKey: String, $liabilityInsuranceCertificateKey: String,$isAllowSendMailConfirm: Boolean,
  $voluntaryInsuranceCertificateExpirationDate: DateTime, $liabilityInsuranceCertificateExpirationDate: DateTime
  ) {
    staffUpdateDoctorCarCommutingApplication(
       id: $id,
       msg: $msg
       status: $status,
       doctorId: $doctorId,
       vehicleType: $vehicleType,
       expirationDate: $expirationDate,
       carCommuteStartDate: $carCommuteStartDate,
       backSideLicenseKey: $backSideLicenseKey,
       frontSideLicenseKey: $frontSideLicenseKey,
       isAllowSendMailConfirm: $isAllowSendMailConfirm,
       licensePlateNumberPart1: $licensePlateNumberPart1,
       licensePlateNumberPart2: $licensePlateNumberPart2,
       licensePlateNumberPart3: $licensePlateNumberPart3,
       licensePlateNumberPart4: $licensePlateNumberPart4,
       vehicleInspectionCertificateKey: $vehicleInspectionCertificateKey,
       liabilityInsuranceCertificateKey: $liabilityInsuranceCertificateKey,
       voluntaryInsuranceCertificateKey: $voluntaryInsuranceCertificateKey,
       vehicleInspectionExpirationDate: $vehicleInspectionExpirationDate
       voluntaryInsuranceCertificateExpirationDate: $voluntaryInsuranceCertificateExpirationDate
       liabilityInsuranceCertificateExpirationDate: $liabilityInsuranceCertificateExpirationDate
    )
  }
`

